import styled from 'styled-components';
import StatusDefault, { getStatusColor, type StatusProps } from './StatusDefault';

const StyledStatus = styled(StatusDefault)`
    background: transparent;
    border: 2px solid ${getStatusColor};

    &:after {
        content: ''; 
        position: absolute;
        left: calc(50% - 1px);
        top: 0px; 
        width: 2px;
        height: 100%;
        background: ${getStatusColor};
        transform: rotate(45deg);
    }
`;

function StatusCrossOut(props: StatusProps) {
    return <StyledStatus {...props} />;
}

export default StatusCrossOut;
